import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.Demos.title',
    defaultMessage: 'Let us hear what your voice can do',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.Demos.subtitle',
    defaultMessage: 'Your voice is a powerful tool that deserves center stage. A good demo is your best presentation card. Let us hear some of you best work and assess the quality of your studio.\n\nWhen uploading demos make sure to provide variety. We allow a maximum of 3 demos per product, so make sure to pick those demos that will make clients go “WOW!”',
  },
  subtitleExtra: {
    id: 'containers.SupplierProfile.components.Demos.subtitleExtra',
    defaultMessage: '-',
  },
  subtitleDialectsAccents: {
    id: 'containers.SupplierProfile.components.Demos.subtitleDialectsAccents',
    defaultMessage: 'If you have a dialect or accent you’d like to highlight, please upload a demo and tag it with the relevant dialect or accent. This will help us find the unique qualities of your voice.',
  },
  specsExpandLabel: {
    id: 'containers.SupplierProfile.components.Demos.specs.expandLabel',
    defaultMessage: 'Show demo specifications',
  },
  specsCollapseLabel: {
    id: 'containers.SupplierProfile.components.Demos.specs.collapseLabel',
    defaultMessage: 'Hide demo specifications',
  },
  specsContent: {
    id: 'containers.SupplierProfile.components.Demos.specs.content',
    defaultMessage: '- Mono or stereo files only\n- WAV format, 44.1kHz or 48kHz, or\n- MP3 format, 128kbps and above\n- 16 or 24 bit\n- Max. length of two minutes\n- Audio may not exceed -14 RMS\n- Audio may not peak 0.1dB\n- Please switch off any and all plugins within your DAW/recording tool\n\nWe want to ensure all demos featured on our website are of the best quality. That way we can get you the exciting jobs you deserve faster.\n\nAre you experiencing problems with your demo upload? \nUsually, the most common error is that files are too loud. For that, we kindly ask you to note that we only accept files from -30RMS to -16RMS.\n\nIf you need help, you can get in touch with us by pressing \'help\' at the top of this page. We will get back to you as soon as possible!',
  },
  studioTitle: {
    id: 'containers.SupplierProfile.components.Demos.studio.title',
    defaultMessage: 'Studio demo',
  },
  studioSubTitle: {
    id: 'containers.SupplierProfile.components.Demos.studio.subtitle',
    defaultMessage: 'We require a raw uncompressed, music free, demo to assess and give feedback on your studio\'s quality. If you need inspiration, download our studio demo script <link>here</link>.',
  },
  auditionTitle: {
    id: 'containers.SupplierProfile.components.Demos.audition.title',
    defaultMessage: 'Audition',
  },
  auditionSubTitle: {
    id: 'containers.SupplierProfile.components.Demos.audition.subtitle',
    defaultMessage: 'Upload an example of your best work to showcase the versatility of your voice. We prefer, that your choose to upload a demo within our most popular products: Commercial, video presentation or e-learning. The sourcing team at VoiceArchive will review your audition.',
  },
  listTitle: {
    id: 'containers.SupplierProfile.components.Demos.list.title',
    defaultMessage: 'Demos',
  },
  listSubTitle: {
    id: 'containers.SupplierProfile.components.Demos.list.subtitle',
    defaultMessage: 'You can change the order of your demos, by dragging them up or down in the list. Your public profile on our website will reflect the displayed order, so you can make sure you\'re showing your favourite demos first.',
  },
  listDownloadAll: {
    id: 'containers.SupplierProfile.components.Demos.list.downloadAll',
    defaultMessage: 'Download all',
  },
  listDrop: {
    id: 'containers.SupplierProfile.components.Demos.list.drop',
    defaultMessage: 'Drag one file here to upload a demo',
  },
  fileSelect: {
    id: 'containers.SupplierProfile.components.Demos.file.select',
    defaultMessage: 'Select file',
  },
  fileApproved: {
    id: 'containers.SupplierProfile.components.Demos.file.approved',
    defaultMessage: 'Approved',
  },
  fileRejected: {
    id: 'containers.SupplierProfile.components.Demos.file.rejected',
    defaultMessage: 'Rejected',
  },
  fileHide: {
    id: 'containers.SupplierProfile.components.Demos.file.hide',
    defaultMessage: 'Hide',
  },
  fileDelte: {
    id: 'containers.SupplierProfile.components.Demos.file.delete',
    defaultMessage: 'Delete',
  },
  fileRearrange: {
    id: 'containers.SupplierProfile.components.Demos.file.rearrange',
    defaultMessage: 'Rearrange',
  },
  filePlay: {
    id: 'containers.SupplierProfile.components.Demos.file.play',
    defaultMessage: 'Play',
  },
  filePause: {
    id: 'containers.SupplierProfile.components.Demos.file.pause',
    defaultMessage: 'Pause',
  },
  fileUpload: {
    id: 'containers.SupplierProfile.components.Demos.file.upload',
    defaultMessage: 'Upload another demo',
  },
  validationFailed: {
    id: 'containers.SupplierProfile.components.Demos.validationFailed',
    defaultMessage: 'To continue, you must upload both a studio demo and an audition.',
  },
  continuePrompt: {
    id: 'containers.SupplierProfile.components.Demos.continuePrompt',
    defaultMessage: 'Great! You\'ve submitted a studio demo and an audition. You will be able to upload more demos if your application will be approved. Click \'Next\' to continue.',
  },
})
